import { queryOptions } from '@tanstack/react-query'
import { isOnServer } from '@shared/constants/util'
import { type GuestStore } from '@/features/shop/services/ShoppingStore/types'
import { userStoreCookie } from '@/features/shop/services/ShoppingStore/cookies'

export const zipUserStoreQueryOptions = queryOptions({
  queryKey: [userStoreCookie.name],
  queryFn: (): GuestStore | null => {
    if (isOnServer()) {
      throw new Error('zipUserStoreQueryOptions queryFn should not be called on the server')
    }
    return userStoreCookie.get() ?? null
  },
  gcTime: Infinity,
  staleTime: Infinity,
})
